// frontend/src/constants/routes.js
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER_COMPLETE: '/register-complete',
  MODALIDADES: '/sports',
  FUNCIONALIDADES: '/features',
  CONTACTO: '/contact',
  PRECO: '/pricing',
  THANK_YOU: '/thank-you',
  TERMS: '/terms',
  POLICY: '/privacy-policy',

  // Clean routes (English)
  FICHA_CLUBE: '/club-sheet',
  PLANTEL: '/squad',
  PLANEJAMENTO: '/weekly-planning',
  EXERCICIOS: '/exercises',
  PLANOS_TREINO: '/training-plans',
  CONVOCATORIA: '/call-up',
  ASSIDUIDADE: '/attendance',
  MODELO_JOGO: '/game-model',
  JOGADAS_ENSAIADAS: '/set-plays',
  COMPETICAO: '/competition',
  PREPARACAO_JOGO: '/match-preparation',
  ANALISE_REFLEXAO: '/analysis-reflection',
  ADVERSARIOS: '/opponents',
  OLHEIRO: '/scout',
  REGISTO_ANUAL: '/annual-record',
  ANALISE_DIRECTA: '/live-analysis',

  // Sport specific overrides - mapping to clean English routes
  FOOTBALL_FICHA_CLUBE: '/club-sheet',
  FOOTBALL_PLANTEL: '/squad',
  FOOTBALL_PLANEJAMENTO: '/weekly-planning',
  FOOTBALL_EXERCICIOS: '/exercises',
  FOOTBALL_PLANOS_TREINO: '/training-plans',
  FOOTBALL_CONVOCATORIA: '/call-up',
  FOOTBALL_ASSIDUIDADE: '/attendance',
  FOOTBALL_MODELO_JOGO: '/game-model',
  FOOTBALL_JOGADAS_ENSAIADAS: '/set-plays',
  FOOTBALL_COMPETICAO: '/competition',
  FOOTBALL_PREPARACAO_JOGO: '/match-preparation',
  FOOTBALL_ANALISE_REFLEXAO: '/analysis-reflection',
  FOOTBALL_ADVERSARIOS: '/opponents',
  FOOTBALL_OLHEIRO: '/scout',
  FOOTBALL_REGISTO_ANUAL: '/annual-record',
  FOOTBALL_ANALISE_DIRECTA: '/live-analysis',

  FUTSAL_FICHA_CLUBE: '/club-sheet',
  FUTSAL_PLANTEL: '/squad',
  FUTSAL_PLANEJAMENTO: '/weekly-planning',
  FUTSAL_EXERCICIOS: '/exercises',
  FUTSAL_PLANOS_TREINO: '/training-plans',
  FUTSAL_CONVOCATORIA: '/call-up',
  FUTSAL_ASSIDUIDADE: '/attendance',
  FUTSAL_MODELO_JOGO: '/game-model',
  FUTSAL_JOGADAS_ENSAIADAS: '/set-plays',
  FUTSAL_COMPETICAO: '/competition',
  FUTSAL_PREPARACAO_JOGO: '/match-preparation',
  FUTSAL_ANALISE_REFLEXAO: '/analysis-reflection',
  FUTSAL_ADVERSARIOS: '/opponents',
  FUTSAL_OLHEIRO: '/scout',
  FUTSAL_REGISTO_ANUAL: '/annual-record',

  ANDEBOL_FICHA_CLUBE: '/club-sheet',
  ANDEBOL_PLANTEL: '/squad',
  ANDEBOL_PLANEJAMENTO: '/weekly-planning',
  ANDEBOL_EXERCICIOS: '/exercises',
  ANDEBOL_PLANOS_TREINO: '/training-plans',
  ANDEBOL_CONVOCATORIA: '/call-up',
  ANDEBOL_ASSIDUIDADE: '/attendance',
  ANDEBOL_MODELO_JOGO: '/game-model',
  ANDEBOL_JOGADAS_ENSAIADAS: '/set-plays',
  ANDEBOL_COMPETICAO: '/competition',
  ANDEBOL_PREPARACAO_JOGO: '/match-preparation',
  ANDEBOL_ANALISE_REFLEXAO: '/analysis-reflection',
  ANDEBOL_ADVERSARIOS: '/opponents',
  ANDEBOL_OLHEIRO: '/scout',
  ANDEBOL_REGISTO_ANUAL: '/annual-record',

  VOLEIBOL_FICHA_CLUBE: '/club-sheet',
  VOLEIBOL_PLANTEL: '/squad',
  VOLEIBOL_PLANEJAMENTO: '/weekly-planning',
  VOLEIBOL_EXERCICIOS: '/exercises',
  VOLEIBOL_PLANOS_TREINO: '/training-plans',
  VOLEIBOL_CONVOCATORIA: '/call-up',
  VOLEIBOL_ASSIDUIDADE: '/attendance',
  VOLEIBOL_MODELO_JOGO: '/game-model',
  VOLEIBOL_JOGADAS_ENSAIADAS: '/set-plays',
  VOLEIBOL_COMPETICAO: '/competition',
  VOLEIBOL_PREPARACAO_JOGO: '/match-preparation',
  VOLEIBOL_ANALISE_REFLEXAO: '/analysis-reflection',
  VOLEIBOL_ADVERSARIOS: '/opponents',
  VOLEIBOL_OLHEIRO: '/scout',
  VOLEIBOL_REGISTO_ANUAL: '/annual-record',

  BASQUETEBOL_FICHA_CLUBE: '/club-sheet',
  BASQUETEBOL_PLANTEL: '/squad',
  BASQUETEBOL_PLANEJAMENTO: '/weekly-planning',
  BASQUETEBOL_EXERCICIOS: '/exercises',
  BASQUETEBOL_PLANOS_TREINO: '/training-plans',
  BASQUETEBOL_CONVOCATORIA: '/call-up',
  BASQUETEBOL_ASSIDUIDADE: '/attendance',
  BASQUETEBOL_MODELO_JOGO: '/game-model',
  BASQUETEBOL_JOGADAS_ENSAIADAS: '/set-plays',
  BASQUETEBOL_COMPETICAO: '/competition',
  BASQUETEBOL_PREPARACAO_JOGO: '/match-preparation',
  BASQUETEBOL_ANALISE_REFLEXAO: '/analysis-reflection',
  BASQUETEBOL_ADVERSARIOS: '/opponents',
  BASQUETEBOL_OLHEIRO: '/scout',
  BASQUETEBOL_REGISTO_ANUAL: '/annual-record',
};